import { makeStyles, tokens } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const useEventFilterTagBarStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    flexWrap: 'wrap',
  },
  filteredByLabel: {
    fontSize: fontScale.body,
    fontWeight: tokens.fontWeightRegular,
    color: tokens.colorNeutralForeground1,
    whiteSpace: 'nowrap',
  },
  pillContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    flexWrap: 'wrap',
  },
  pill: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
  },
  pillContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
    backgroundColor: tokens.colorNeutralBackground3,
    paddingTop: '0.25rem',
    paddingBottom: '0.25rem',
    paddingLeft: tokens.spacingHorizontalS,
    paddingRight: tokens.spacingHorizontalS,
    borderRadius: '0.75rem',
    borderTopRightRadius: '0rem',
    borderBottomRightRadius: '0rem',
    cursor: 'pointer',
    border: 'none',
    font: 'inherit',
  },
  pillLabel: {
    fontSize: fontScale.body,
    fontWeight: tokens.fontWeightRegular,
    color: tokens.colorNeutralForeground2,
  },
  pillValue: {
    fontSize: fontScale.body,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground2,
  },
  pillDismiss: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: tokens.colorNeutralBackground3,
    width: '1.5rem',
    height: '1.875rem',
    borderRadius: '0.75rem',
    borderTopLeftRadius: '0rem',
    borderBottomLeftRadius: '0rem',
    cursor: 'pointer',
    border: 'none',
    color: tokens.colorNeutralForeground3,
    ':hover': {
      backgroundColor: tokens.colorNeutralBackground4,
      color: tokens.colorNeutralForeground1,
    },
  },
  clearAllButton: {
    minWidth: 'auto',
    color: tokens.colorBrandForegroundLink,
    marginLeft: tokens.spacingHorizontalXS,
  },
  inlinePopoverMessage: {
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalS,
    paddingRight: tokens.spacingHorizontalS,
  },
  inlineSearchContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
    minWidth: '16rem',
  },
  inlineListbox: {
    maxHeight: '20rem',
    overflowY: 'auto',
  },
});
